// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StackedAreaPlot {
  height: 100%;
}
.StackedAreaPlot .chart {
  /* margin-top: 1.2rem; */
  height: 90%;
  padding: 2rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 1rem;
}
.StackedAreaPlot .text {
  display: flex;
  justify-content: space-around;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/StackedAreaPlot.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,iDAAiD;EACjD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":[".StackedAreaPlot {\n  height: 100%;\n}\n.StackedAreaPlot .chart {\n  /* margin-top: 1.2rem; */\n  height: 90%;\n  padding: 2rem;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  border-radius: 1rem;\n}\n.StackedAreaPlot .text {\n  display: flex;\n  justify-content: space-around;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
